import { render, staticRenderFns } from "./InfoInstitucion.vue?vue&type=template&id=b5227da2&scoped=true"
import script from "./InfoInstitucion.vue?vue&type=script&lang=js"
export * from "./InfoInstitucion.vue?vue&type=script&lang=js"
import style0 from "./InfoInstitucion.vue?vue&type=style&index=0&id=b5227da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5227da2",
  null
  
)

export default component.exports